import React, { useState } from "react"
import TasksPage from "./TasksPage"
import AddTask from "./AddTask"
import EditTask from "./EditTask"

const TasksTab = ({ userId, userData }) => {
  const [activeTab, setActiveTab] = useState('tasks')
  const [taskId, setTaskId] = useState('')
  const [isUpdated, setIsUpdated] = useState(false)

  return (
    <>
      {activeTab === "tasks" && <TasksPage setActiveTab={setActiveTab} userId={userId} setTaskId={setTaskId} setIsUpdated={setIsUpdated} isUpdated={isUpdated}/>}
      {activeTab === "addTask" && <AddTask setActiveTab={setActiveTab} userId={userId} userData={userData}/>}
      {activeTab === "editTask" && <EditTask setActiveTab={setActiveTab} userId={userId} taskId={taskId} setIsUpdated={setIsUpdated} isUpdated={isUpdated}/>}
    </>

  )
}

export default TasksTab